import React, { Component } from 'react';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import { signUp } from '../../store/actions/authActions';
import { connect } from 'react-redux';

class SignUp extends Component {
    state = {
        email: '',
        password: '',
        firstName: '',
        lastName: '',
    };

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        });
    };

    handleSubmit = () => {
      const information = {
        ...this.state
      }

      information.firstName = information.firstName.toUpperCase()
      information.lastName = information.lastName.toUpperCase()
      console.log('signup')
      this.props.signUp(information);
    };

    render() {
        return (
          <Form onSubmit={this.handleSubmit}>
            <h2>Sign Up</h2>
            <h4>Enter your information to create a trading profile.</h4><br />
            <FormGroup>
              <Input type="text" name="firstName" id="firstName" placeholder="First Name:" value={this.state.firstName.toUpperCase()} onChange={this.handleChange} />
            </FormGroup>
            <FormGroup>
              <Input type="text" name="lastName" id="lastName" placeholder="Last Name:" value={this.state.lastName.toUpperCase()} onChange={this.handleChange} />
            </FormGroup>
            <FormGroup>
              <Input type="email" name="email" id="email" placeholder="Email Address:" onChange={this.handleChange} />
            </FormGroup>
            <FormGroup>
              <Input type="password" name="password" id="password" placeholder="Password:" onChange={this.handleChange} />
            </FormGroup>
            <Button color="primary"  onClick={(e) => this.handleSubmit()}>Register</Button>
          </Form>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        mode: state.mode,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signUp: (newUser) => dispatch(signUp(newUser)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
